export default __webpack_public_path__ + "static/alfgrev-8e911c029c296983db5061947216a917.jpg";